import {createWebHistory, createRouter} from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import store from '@/store'


import HomeView from './components/HelloWorld.vue'
import ShopLine from './ShopLine.vue'
import Contact from './components/Contact.vue'
import About from './About-Us.vue'
import productId from './productId.vue'
import pagehome from './pageHome.vue'
import Editproduct from './components/EditProduct.vue'
import Search from "./components/SearchApp.vue";
import Login from "./LoginApp.vue"
import Dashboard from "./DashboardApp.vue"
import cart from "./CartApp.vue"

/*const routes = [
    { path: '/', component: HomeView },
    { path: '/shop', component: ShopLine },
]*/

const routes = [
    {
        path: '/',
        name: 'home',
        component: pagehome,
        // meta: { showHeader: true }
    },
    {
        path: '/products',
        // query: {  page: 1 },
        props: (route) => ({query: route.query.q}),
        name: 'products',
        component: HomeView,
        // meta: { showHeader: true }
    },
    {
        path: '/product/:id',
        name: 'productId',
        component: productId,
        meta: {showHeader: true}
    },
    {
        path: '/shop',
        name: 'shop',
        component: ShopLine,
        meta: {showHeader: true}
    },
    {
        path: '/contact',
        name: 'contact',
        component: Contact,
        meta: {showHeader: false}
    },
    {
        path: '/About',
        name: 'About',
        component: About,
        meta: {showHeader: false}
    },
    {
        path: '/Editproduct',
        name: 'Editproduct',
        component: Editproduct,
        // meta: {showHeader: false}
    },
    {
        path: '/search',
        name: 'search',
        component: Search,
        // meta: {showHeader: false}
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        // meta: {showHeader: false}
    },
    {
        path: '/Dashboard',
        name: 'Dashboard',
        component: Dashboard,
        // meta: {showHeader: false}
        meta: { requiresAuth: true }
    },
    {
        path: '/cart',
        name: 'cart',
        component: cart,
        // meta: {showHeader: false}
        // meta: { requiresAuth: true }
    },

   /* {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('@/views/NotFoundView.vue'),
        meta: {
            title: 'صفحه یافت نشد'
        }
    }*/
]








const router = createRouter({
    history: createWebHistory(),
    routes
})



router.beforeEach((to, from, next) => {
    NProgress.start()
    next()
})

// توقف NProgress بعد از کامل شدن مسیریابی
router.afterEach(() => {
    NProgress.done()
})

NProgress.configure({ showSpinner: false, speed: 400 })


router.beforeEach((to, from, next) => {
    const isLoggedIn = store.getters.isAuthenticated

    if (to.meta.requiresAuth && !isLoggedIn) {
        next({ name: 'login' }) // اگر نیاز به احراز هویت داشت و وارد نشده بود
    } else if (to.name === 'login' && isLoggedIn) {
        next({ name: 'Dashboard' }) // اگه لاگین بود و خواست بره به صفحه لاگین
    } else {
        next() // در غیر این صورت اجازه ورود بده
    }
})



export default router;